import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ModalBody } from "reactstrap";
import { getTrainers } from "../../redux/actions/api/apiAction";
import { ServicesTitle } from "./modalTitle";
import { ModalTabs } from "./tabs";
import { navTabs, navTabsForCourt, tabsComponent } from "./utils";

export const AddService = ({ toggleModal }) => {
  const [activeTab, setActiveTab] = React.useState(1);
  const { gym } = useSelector((state) => state.gym);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(
      getTrainers(
        1,
        1000,
        JSON.parse(localStorage.getItem("connectToFitGymPanelUser")).gym,
        "","", "Y"
      )
    );
  }, []);

  return (
    <>
      <ServicesTitle />
      <ModalBody className="mx-1 py-3">
        <ModalTabs
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          navTabs={gym.type == "sportClub" ? navTabsForCourt : navTabs}
          tabsComponent={tabsComponent}
        />
      </ModalBody>
    </>
  );
};
